import { render, staticRenderFns } from "./PalletRackGable.vue?vue&type=template&id=0964b24c"
import script from "./PalletRackGable.vue?vue&type=script&lang=js"
export * from "./PalletRackGable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports